import { DocumentationLegacyPageBlockFrame, } from "./blocks/SDKDocumentationLegacyPageBlockFrame";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageAsset {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d;
        this.id = model.id;
        this.persistentId = (_a = model.persistentId) !== null && _a !== void 0 ? _a : null;
        this.sourceId = (_b = model.sourceId) !== null && _b !== void 0 ? _b : null;
        this.sourceFrameId = (_c = model.sourceFrameId) !== null && _c !== void 0 ? _c : null;
        this.url = (_d = model.url) !== null && _d !== void 0 ? _d : null;
        this.type = model.type;
        this.frame = model.figmaFrame
            ? new DocumentationLegacyPageBlockFrame(model.figmaFrame, null)
            : null;
    }
}
